'use client';

import Link from '@/components/ActiveLink'
import './styles.css'

export default function Navbar () {
  return (
    <nav id="main-navbar">
      <Link href="/">About</Link>
      <Link href="/experiences">Experiences</Link>
      <Link href="/technologies">Technologies</Link>
    </nav>
  )
}
